const termsHtml = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>Terms &amp; Conditions - Class Copilot</title>

  <style>
    body {
      margin: 0;
      padding: 0;
      font-family: Arial, sans-serif;
      background: #f7f7f7;
      color: #222;
      line-height: 1.7;
    }

    .container {
      max-width: 900px;
      margin: 40px auto;
      background: #fff;
      padding: 40px;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.08);
    }

    h1, h2 {
      color: #191645;
    }

    h1 {
      text-align: center;
      margin-top: 0;
    }

    h2 {
      margin-top: 30px;
      border-bottom: 1px solid #eee;
      padding-bottom: 6px;
    }

    p {
      margin: 12px 0;
    }

    ul {
      margin-left: 20px;
    }

    li {
      margin-bottom: 8px;
    }

    .meta {
      text-align: center;
      color: #666;
      margin-bottom: 30px;
    }

    .contact {
      background: #f3f4ff;
      padding: 20px;
      border-radius: 10px;
      margin-top: 20px;
    }

    @media (max-width: 768px) {
      .container {
        margin: 16px;
        padding: 24px;
      }
    }
  </style>
</head>

<body>
  <div class="container">

    <h1>Terms &amp; Conditions</h1>
    <p class="meta">
      <strong>Class Copilot</strong><br/>
      Effective Date: 2026-04-19
    </p>

    <h2>1. Acceptance of Terms</h2>
    <p>
      By using the Class Copilot mobile application and services, you agree to these Terms &amp; Conditions.
      If you do not agree, please do not use the app.
    </p>

    <h2>2. About the Service</h2>
    <p>
      Class Copilot is an educational platform that allows teachers to manage classes, share materials,
      assign homework, and interact with students.
    </p>

    <h2>3. User Accounts</h2>
    <ul>
      <li>You must provide accurate information when creating an account</li>
      <li>You are responsible for maintaining account security</li>
      <li>You are responsible for all activity under your account</li>
    </ul>

    <h2>4. Acceptable Use</h2>
    <p>You agree NOT to:</p>
    <ul>
      <li>Use the app for illegal purposes</li>
      <li>Upload harmful, abusive, or inappropriate content</li>
      <li>Attempt to hack, disrupt, or misuse the system</li>
      <li>Impersonate other users</li>
    </ul>

    <h2>5. Content</h2>
    <p>
      Users (teachers and students) may upload content such as assignments, PDFs, and videos.
    </p>
    <ul>
      <li>You retain ownership of your content</li>
      <li>You grant us permission to store and display content within the app</li>
      <li>You are responsible for the content you upload</li>
    </ul>

    <h2>6. Payments (if applicable)</h2>
    <p>
      Some features may require payment or subscription.
    </p>
    <ul>
      <li>All payments are handled securely</li>
      <li>Fees are non-refundable unless stated otherwise</li>
      <li>We may change pricing with notice</li>
    </ul>

    <h2>7. Termination</h2>
    <p>
      We may suspend or terminate your account if you violate these Terms.
    </p>

    <h2>8. Limitation of Liability</h2>
    <p>
      We are not responsible for:
    </p>
    <ul>
      <li>Loss of data</li>
      <li>Service interruptions</li>
      <li>Content shared by users</li>
    </ul>

    <h2>9. Privacy</h2>
    <p>
      Your use of the app is also governed by our Privacy Policy.
    </p>

    <h2>10. Changes to Terms</h2>
    <p>
      We may update these Terms at any time. Continued use of the app means you accept the changes.
    </p>

    <h2>11. Governing Law</h2>
    <p>
      These Terms are governed by the laws of Sri Lanka.
    </p>

    <h2>12. Contact Us</h2>
    <div class="contact">
      <p><strong>I T WAVES (PRIVATE) LIMITED</strong></p>
      <p>No 183, Sunanda Mawatha, Walgama, Matara, Sri Lanka</p>
      <p>Email: mgmskumara@gmail.com</p>
      <p>Phone: +94 71 384 8468</p>
    </div>

  </div>
</body>
</html>`;

export default termsHtml;
